/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */

import { jsx } from "@emotion/core"
import { FC } from "react"
import { Modal, Button } from "@duxton-web/ui"
import { useTranslation } from "common/utils/i18n"
import { useDispatch, useSelector } from "react-redux"
import { AppState } from "store/store.type"
import { actionCreator } from "store/store"

export const ChunkErrorModal: FC = () => {
  const { showChunkErrorModal } = useSelector((state: AppState) => state.global)
  const dispatch = useDispatch()

  const handleToggleModal = () => {
    dispatch(actionCreator.global.toggleChunkErrorModal())
  }

  const handleReload = () => window.location.reload()

  return (
    <Modal
      destroyOnClose
      closable={false}
      title={useTranslation("common.errorChunk.unstableConnection")}
      width={400}
      open={showChunkErrorModal}
      onCancel={handleToggleModal}
      footer={[
        <Button key="cancel" style={{ width: "45%" }} onClick={handleReload}>
          {useTranslation("common.errorChunk.reload")}
        </Button>,
      ]}
    >
      <p>{useTranslation("common.errorChunk.pleaseReload")}</p>
    </Modal>
  )
}
